import type React from 'react';
import { useState } from 'react';

interface InsurerLogoProps {
	slug: string;
	format?: 'png' | 'svg';
	alt?: string;
	className?: string;
}

const InsurerLogo = ({
	slug,
	format = 'png',
	alt = '',
	className
}: InsurerLogoProps): React.JSX.Element | null => {
	const [failedLogoPaths, setFailedLogoPaths] = useState<string[]>([]);

	const API_URL = import.meta.env.VITE_API_BASE_URL as string;
	const requestedLogoPath = `${slug}/logo.${format}`;
	const currentFormat =
		format === 'svg' && failedLogoPaths.includes(requestedLogoPath) ? 'png' : format;
	const currentLogoPath = `${slug}/logo.${currentFormat}`;
	const hasError = failedLogoPaths.includes(currentLogoPath);

	if (hasError) {
		if (!alt) return null;
		return (
			<span className="text-xs text-muted-foreground font-medium leading-tight whitespace-nowrap">
				{alt}
			</span>
		);
	}

	return (
		<img
			src={`${API_URL}/assets/providers/${slug}/logo.${currentFormat}`}
			alt={alt}
			className={className}
			onError={() => {
				setFailedLogoPaths((currentPaths) =>
					currentPaths.includes(currentLogoPath) ? currentPaths : [...currentPaths, currentLogoPath]
				);
			}}
		/>
	);
};

export default InsurerLogo;
